import type {Component} from 'typings/portaro.fe.types';
import type {IOnDestroy, IOnInit, IScope} from 'angular';
import type {KpVideoViewerComponentController} from './kp-video-viewer.component';

export class KpVideoViewerEventWrapperComponentController implements IOnInit, IOnDestroy {

    private videoViewerController: KpVideoViewerComponentController;
    private deregisterQueue: Array<() => void> = [];

    /*@ngInject*/
    constructor(private $scope: IScope) {
    }

    public $onInit(): void {
        this.deregisterQueue.push(this.$scope.$on(KpVideoViewerEvent.SET_URL, (event, url) => this.videoViewerController.setUrl(url)));
        this.deregisterQueue.push(this.$scope.$on(KpVideoViewerEvent.SET_ASPECT_RATIO, (event, aspectRatio) => this.videoViewerController.setAspectRatio(aspectRatio)));
    }

    public $onDestroy(): void {
        this.deregisterQueue.forEach((listener) => listener());
    }

    public registerVideoViewer(videoViewerController: KpVideoViewerComponentController) {
        this.videoViewerController = videoViewerController;
    }
}

/**
 * @ngdoc component
 * @name kpVideoViewerEventWrapper
 * @module portaro.components
 *
 * @description
 *
 */
export default class KpVideoViewerEventWrapperComponent implements Component<never> {
    public static componentName = 'kpVideoViewerEventWrapper';

    public template = '<ng-transclude></ng-transclude>';

    public transclude = true;

    public controller = KpVideoViewerEventWrapperComponentController;
}

export enum KpVideoViewerEvent {
    SET_URL = 'kpViewViewer:setUrl',
    SET_ASPECT_RATIO = 'kpViewViewer:setAspectRatio'
}
